module.exports = __webpack_public_path__ + "img/Unidad13-3.09f7c31d.png";